module.exports = __webpack_public_path__ + "assets/img/plant-2.7fd03345.png";